import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import dotNotationMapper from '../../data/dotNotationMapper';
import validator from 'validator';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;
        const {
            companyId='', inhouz_reserved_parameters_xyzh={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        let variableCopy = parsedParameters['variableObject'];
        if(parsedParameters.error){
            variableCopy[variableName] = {
                error : {
                    message : 'Failed to parse function data.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];

        let userList = resolvedParams['userList'] || [];
        if(
            !Array.isArray(userList) ||
            (userList.length === 0)
        ){
            variableCopy[variableName] = {
                error : {
                    message : 'Invalid user list.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Invalid user list.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let signupUserFormUsers = [], adminUserEmail='';
        for (let i = 0; i < userList.length; i++){
            let userObj = userList[i];
            let signupUser = {
                firstName : dotNotationMapper(userObj, resolvedParams['firstNameField']) || '',
                lastName : dotNotationMapper(userObj, resolvedParams['lastNameField']) || '',
                email : dotNotationMapper(userObj, resolvedParams['emailField']) || '',
                dob : dotNotationMapper(userObj, resolvedParams['dobField']) || '',
                sex : dotNotationMapper(userObj, resolvedParams['sexField']) || '',
                isAdmin : dotNotationMapper(userObj, resolvedParams['isAdminField']) === true ? true : false,
                organizationName : resolvedParams['organizationName'] || ''
            }

            if(
                !validator.isEmail(signupUser['email'])
            ){
                continue;
            }else{
                signupUserFormUsers.push(signupUser);
                if(!adminUserEmail){
                    if(signupUser['isAdmin']){
                        adminUserEmail = signupUser['email'];
                    }
                }
            }
        }

        if(signupUserFormUsers.length === 0){
            variableCopy[variableName] = {
                error : {
                    message : 'Missing valid external users.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Missing valid external users.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!adminUserEmail){
            variableCopy[variableName] = {
                error : {
                    message : 'At least one Admin user is required for initial sign up.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'At least one Admin user is required for initial sign up.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['X-API-KEY']){
            variableCopy[variableName] = {
                error : {
                    message : 'API key is missing.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'API key is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['subscriptionServiceId']){
            variableCopy[variableName] = {
                error : {
                    message : 'subscriptionServiceId is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'subscriptionServiceId is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['subscriptionServiceTierId']){
            variableCopy[variableName] = {
                error : {
                    message : 'subscriptionServiceTierId is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'subscriptionServiceTierId is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['organizationName']){
            variableCopy[variableName] = {
                error : {
                    message : 'organizationName is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'organizationName is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let signupBillingAddress = {};
        if(
            resolvedParams['billingAddressLine1']
        ){
            signupBillingAddress = {
                line1 : resolvedParams['billingAddressLine1'],
                line2 : resolvedParams['billingAddressLine2'] || '',
                city : resolvedParams['billingAddressCity'] || '',
                state : resolvedParams['billingAddressState'] || '',
                country : resolvedParams['billingAddressCountry'] || '',
                zipcode : resolvedParams['billingAddressZipcode'] || ''
            }
        }

        let clientEncryptedApiHeader = encryptDecrypt(
            JSON.stringify({
                payload : {
                    'X-API-KEY' : resolvedParams['X-API-KEY'],
                    companyId,
                    queryKey : `${Math.random()}${Math.random()}${Math.random()}${new Date().getTime()}`,
                    environment : appEnvironment
                },
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let payload = {
            signupUserFormUsers,
            adminUserEmail,
            assetOwnerCompanyId : companyId,
            subscriptionServiceId : resolvedParams['subscriptionServiceId'],
            subscriptionServiceTierId : resolvedParams['subscriptionServiceTierId'],
            signupBillingAddress,
            organizationName : resolvedParams['organizationName'] || '',
            setupIntentId : resolvedParams['stripeSetupIntentId'] || '',
            planRegistrationCurrency : resolvedParams['currency'] || 'USD',
            onDemandPaymentAcknowledgement : resolvedParams['onDemandPaymentAcknowledgement'] === true ? true : false,
            deviceMode : 'desktop',
            environment : appEnvironment,
            functionGenerated : true,
            webhookMetadata : resolvedParams['webhookMetadata'] || {}
        }

        if(
            payload['setupIntentId'] && 
            !payload['onDemandPaymentAcknowledgement']
        ){
            variableCopy[variableName] = {
                error : {
                    message : 'On Demand Payment Acknowledgement is required when Stripe Setup Intent ID is provided.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'On Demand Payment Acknowledgement is required when Stripe Setup Intent ID is provided.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            payload['setupIntentId'] && 
            !payload['planRegistrationCurrency']
        ){
            variableCopy[variableName] = {
                error : {
                    message : 'Currency is required when Stripe Setup Intent ID is provided.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Currency is required when Stripe Setup Intent ID is provided.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let encryptedPayload = encryptDecrypt(JSON.stringify({
            payload,
            expirationTimestamp : moment().add(5, 'minutes').unix() * 1000
        }))

        let response = await fetch(
            `${config.devServerProxy}/api/subscribe/automatedinitialexternalsignup`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache',
                    'X-CE-API-KEY' : clientEncryptedApiHeader
                },
                credentials : 'omit',
                body : JSON.stringify({encryptedPayload})
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/signupSubscriptionServiceExternalUsersParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}